import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ppeConfidencePercent } from 'app/services/PPE/ppe.models';

/**
 * Small "AI" pill for observations created by PPE auto-detection (V2CORE-2901).
 * Tooltip: "Created by PPE auto-detection, confidence 91%" (no percentage when
 * the confidence is missing). `confidence` accepts 0..1 or 0..100.
 */
@Component({
  selector: 'app-ai-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      *transloco="let t"
      class="ai-badge inline-flex items-center rounded px-1 text-xs font-semibold leading-4 uppercase bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-200"
      [attr.aria-label]="tooltipText(t)"
      [matTooltip]="tooltipText(t)"
      >{{ t('ppe.ai.badge') }}</span
    >
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        vertical-align: middle;
      }
    `,
  ],
})
export class AiBadgeComponent {
  /** AI confidence (`ppe_detection_confidence`), 0..1 or 0..100; null hides the percentage. */
  @Input() confidence: number | string | null | undefined;

  get percent(): number | null {
    return ppeConfidencePercent(this.confidence);
  }

  tooltipText(t: (key: string, params?: Record<string, unknown>) => string): string {
    const percent = this.percent;
    return percent === null
      ? t('ppe.ai.tooltip_no_confidence')
      : t('ppe.ai.tooltip', { confidence: percent });
  }
}
